import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { useSelector } from 'react-redux';

import OlMap from '@/helpers/OlMap';

const useCameraFeedback = (robotId) => {
  const cameraFeedback = useSelector((state) => state.telemetry[robotId]?.cameraFeedback);

  useMountEffect(() => {
    return () => {
      OlMap.removeShoot(robotId);
    };
  });

  useUpdateEffect(() => {
    if (!cameraFeedback) return;

    const { lat, lng } = cameraFeedback;
    OlMap.addShoot(robotId, { lat, lng });
  }, [cameraFeedback]);
};

export default useCameraFeedback;
